/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiLeadStatusTypeFromJSON, ApiLeadStatusTypeToJSON, } from './ApiLeadStatusType';
export function ApiSalesFlowPayloadFromJSON(json) {
    return ApiSalesFlowPayloadFromJSONTyped(json, false);
}
export function ApiSalesFlowPayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'closedFunnel': !exists(json, 'closedFunnel') ? undefined : json['closedFunnel'],
        'from': !exists(json, 'from') ? undefined : (new Date(json['from'])),
        'lastNDays': !exists(json, 'lastNDays') ? undefined : json['lastNDays'],
        'leadStatus': !exists(json, 'leadStatus') ? undefined : ApiLeadStatusTypeFromJSON(json['leadStatus']),
        'to': !exists(json, 'to') ? undefined : (new Date(json['to'])),
    };
}
export function ApiSalesFlowPayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'closedFunnel': value.closedFunnel,
        'from': value.from === undefined ? undefined : (value.from.toISOString()),
        'lastNDays': value.lastNDays,
        'leadStatus': ApiLeadStatusTypeToJSON(value.leadStatus),
        'to': value.to === undefined ? undefined : (value.to.toISOString()),
    };
}
